import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/operations/company")({
  component: () => (
    <PlaceholderPanel
      title="Company Dashboard"
      description="Per-company deep dive: Status Board, Document Hub, Agent Console, Digest Dashboard, Teams integration"
    />
  ),
})
